module.exports = __webpack_public_path__ + "img/tan.903f4acf.png";